import {
    map,
    set,
    get,
    filter,
    first,
    keyBy,
    reduce,
    cloneDeep,
    uniq,
    uniqBy,
    difference,
    includes,
    flatten,
    groupBy, forOwn, random, truncate,
    find,
    assign, debounce, throttle,
    indexOf, remove, reject,
    isObject,
    isPlainObject,
    sortBy,
    has, capitalize,
    defaultTo,
    uniqueId,
    startCase,
} from 'lodash-es';

export default {
    map,
    get,
    set,
    filter,
    keyBy,
    debounce,
    throttle,
    reduce,
    find,
    assign,
    cloneDeep,
    uniq,
    uniqBy,
    difference,
    flatten,
    includes,
    groupBy,
    indexOf,
    first,
    forOwn,
    remove,
    reject,
    random,
    truncate,
    isObject,
    isPlainObject,
    findGet: (arr, search=(item) => item, title, defaultTitle=null) => {
        return get(find(arr, search), title)
    },
    sortBy,
    has,
    capitalize,
    defaultTo,
    uniqueId,
    startCase,
}